import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import HomePage from './pages/HomePage';
import BrowsePage from './pages/BrowsePage';
import ListingDetailPage from './pages/ListingDetailPage';
import PostJobPage from './pages/PostJobPage';
import ServicesPage from './pages/ServicesPage';
import TalentNetworkPage from './pages/TalentNetworkPage';
import CrewNetworkPage from './pages/CrewNetworkPage';
import WhyJoinPage from './pages/WhyJoinPage';
import TermsPage from './pages/TermsPage';
import AboutPage from './pages/AboutPage';
import OGCoverPreview from './pages/OGCoverPreview';
import OGCoverRender from './pages/OGCoverRender';
import HireThroughUsPage from './pages/HireThroughUsPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboard from './pages/AdminDashboard';
import GoogleAnalytics from './components/GoogleAnalytics';
import './App.css';

function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <BrowserRouter>
        <GoogleAnalytics />
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/browse" element={<BrowsePage />} />
            <Route path="/listing/:id" element={<ListingDetailPage />} />
            <Route path="/post-job" element={<PostJobPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/talent" element={<Navigate to="/talent/professional" replace />} />
            <Route path="/talent/professional" element={<TalentNetworkPage />} />
            <Route path="/talent/crew" element={<CrewNetworkPage />} />
            <Route path="/talent/why-join" element={<WhyJoinPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/og-cover" element={<OGCoverPreview />} />
            <Route path="/og-render" element={<OGCoverRender />} />
            <Route path="/hire" element={<HireThroughUsPage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          <Toaster position="top-right" />
        </div>
      </BrowserRouter>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;